import { API_BASE_URL } from './config.js';
import fetchWrapper from '../components/utility/fetchWrapper.js';

export const healthService = {
  /**
   * Fetch health status from the backend
   * @returns {Promise<Object>} Health status object with status, timestamp, version, checks, etc.
   */
  getHealthStatus: async () => {
    try {
      const response = await fetchWrapper(`${API_BASE_URL}/health/`);
      if (!response.ok) {
        throw new Error(`Health check failed: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching health status:', error);
      throw error;
    }
  },
};
